import { privateFetch } from "api/privateFetch";

const getParents = async (id) => {
  const { data } = await privateFetch.get(`/csm/${id}/parents`);
  return data;
};

export default getParents;
